<template>
  <modal
    name="social-share-modal"
    adaptive
    height="auto"
    width="90%"
    :max-width="450"
    :click-to-close="true"
  >
    <div class="social-share-modal">
      <font-awesome-icon icon="times" class="close-icon" @click="close" />
      <social-sharing
        :url="currentUrl ? currentUrl : ''"
        :title="
          project && project.title
            ? `MzingoPartners.com presents ${project.title}`
            : `MzingoPartners.com`
        "
        :description="
          `MzingoPartners.com is connecting individuals like you and me directly with people and communities in need. I encourage you to check out this project to fund the change you want to see in the world.`
        "
        :quote="
          `MzingoPartners.com is connecting individuals like you and me directly with people and communities in need. I encourage you to check out this project to fund the change you want to see in the world.`
        "
        hashtags="mzingopartners"
        twitter-user="mzingo_partners"
        inline-template
      >
        <div style="text-align: center">
          <ul>
            <li style="margin-top: 1.25rem; font-size: 1.25rem; cursor: pointer;">
              <network network="email">
                <font-awesome-icon icon="envelope" style="margin-right: 0.5rem; color: #df542f;" />
                Email
              </network>
            </li>
            <li
              class="medium-button"
              style="margin-top: 1.25rem; font-size: 1.25rem; cursor: pointer;"
            >
              <div>
                <network network="facebook">
                  <font-awesome-icon
                    :icon="['fab', 'facebook']"
                    style="margin-right: 0.5rem; color: #df542f;"
                  />Facebook
                </network>
              </div>
            </li>
            <li
              class="medium-button"
              style="margin-top: 1.25rem; font-size: 1.25rem; cursor: pointer;"
            >
              <network network="linkedin">
                <font-awesome-icon
                  :icon="['fab', 'linkedin']"
                  style="margin-right: 0.5rem; color: #df542f;"
                />LinkedIn
              </network>
            </li>
            <li
              class="medium-button"
              style="margin-top: 1.25rem; font-size: 1.25rem; cursor: pointer;"
            >
              <network network="twitter">
                <font-awesome-icon
                  :icon="['fab', 'twitter']"
                  style="margin-right: 0.5rem; color: #df542f;"
                />Twitter
              </network>
            </li>
            <li
              class="medium-button"
              style="margin-top: 1.25rem; font-size: 1.25rem; cursor: pointer;"
            >
              <network network="whatsapp">
                <font-awesome-icon
                  :icon="['fab', 'whatsapp']"
                  style="margin-right: 0.5rem; color: #df542f;"
                />Whatsapp
              </network>
            </li>
          </ul>
        </div>
      </social-sharing>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'SocialShareModal',
  props: {
    project: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentUrl: '',
    }
  },
  created() {
    this.currentUrl = window.location.href

    this.$root.$on('social_shares_open', function(network) {
      /** Google Analytics - Send "Social Share to {{channel; e.g. facebook}}" event to GA. */
      this.$ga.event({
        eventCategory: `Social Share to ${network}`,
      })
    })
  },
  methods: {
    open() {
      this.$modal.show('social-share-modal')
    },
    close() {
      this.$modal.hide('social-share-modal')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/buttons';

.social-share-modal {
  padding: 1rem;
}

.close-icon {
  float: right;
  cursor: pointer;
}
</style>
